/* ANIME STYLE product page: option buttons -> variant, price + URL, AJAX add to bag, gallery dots, sticky bar, stats animation. */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-as-pdp]');
  if (!pdp) return;
  var variants = JSON.parse(document.querySelector('[data-as-variants]').textContent);
  var form = pdp.querySelector('[data-as-form]');
  var idInput = pdp.querySelector('[data-as-variant-input]');
  var addBtn = pdp.querySelector('[data-as-add]');

  function selectedOptions() {
    return Array.prototype.map.call(pdp.querySelectorAll('[data-as-option]'), function (fs) {
      var on = fs.querySelector('button[aria-pressed="true"]');
      return on ? on.dataset.value : null;
    });
  }

  function findVariant(opts) {
    return variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; }); });
  }

  function markAvailability(opts) {
    pdp.querySelectorAll('[data-as-option]').forEach(function (fs, i) {
      fs.querySelectorAll('button').forEach(function (b) {
        var test = opts.slice(); test[i] = b.dataset.value;
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); });
        b.classList.toggle('is-unavailable', !v || !v.available);
      });
    });
  }

  /* The page opens on the product's main photo. Another colour puts its variant photo in the big first slot;
     the first variant's colour (the one the main photo shows) brings the main photo back. */
  var stage = pdp.querySelector('[data-as-gallery]');
  var originalShots = stage ? Array.prototype.slice.call(stage.children) : [];
  var homeMediaId = variants[0] && variants[0].featured_media ? variants[0].featured_media.id : null;

  function showVariantMedia(variant) {
    if (!stage || !originalShots.length || !variant || !variant.featured_media) return;
    var isHome = variant.featured_media.id === homeMediaId;
    var lead = isHome ? originalShots[0] : stage.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
    if (!lead || lead === stage.firstElementChild) return;
    var order = isHome ? originalShots : [lead].concat(originalShots.filter(function (s) { return s !== lead; }));
    stage.firstElementChild.classList.remove('as-shot--first');
    order.forEach(function (s) { stage.appendChild(s); });
    lead.classList.add('as-shot--first');
    var img = lead.querySelector('img[loading="lazy"]');
    if (img) img.loading = 'eager';
    stage.scrollTo({ left: 0, behavior: 'smooth' });
    if (window.matchMedia('(min-width: 961px)').matches && stage.getBoundingClientRect().top < 0) {
      stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function update(variant) {
    if (!variant) return;
    idInput.value = variant.id;
    fetchPrice(variant);
    addBtn.disabled = !variant.available;
    addBtn.dataset.available = variant.available ? '1' : '0';
    showVariantMedia(variant);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  /* Prices are formatted by Shopify on the server: re-read them from the section in the new variant's context. */
  function fetchPrice(variant) {
    var url = pdp.dataset.productUrl + '?variant=' + variant.id + '&section_id=' + pdp.dataset.section;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['[data-as-price]', '[data-as-compare]', '[data-as-add]'].forEach(function (sel) {
        var fresh = doc.querySelector(sel), old = pdp.querySelector(sel);
        if (fresh && old) { old.innerHTML = fresh.innerHTML; old.hidden = fresh.hidden; }
      });
      var sticky = document.querySelector('[data-as-sticky-price]');
      var p = doc.querySelector('[data-as-price]');
      if (sticky && p) sticky.textContent = p.textContent;
      addBtn.disabled = addBtn.dataset.available !== '1';
    }).catch(function () {});
  }

  pdp.querySelectorAll('[data-as-option]').forEach(function (fs) {
    fs.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-value]');
      if (!b) return;
      fs.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var label = fs.querySelector('[data-as-option-value]');
      if (label) label.textContent = b.dataset.value;
      var opts = selectedOptions();
      markAvailability(opts);
      update(findVariant(opts));
    });
  });
  markAvailability(selectedOptions());

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!window.asTheme || addBtn.disabled) return;
    var r = addBtn.getBoundingClientRect();
    addBtn.disabled = true;
    window.asTheme.addToBag([{ id: Number(idInput.value), quantity: 1 }], { x: r.left + r.width / 2, y: r.top })
      .finally(function () { addBtn.disabled = addBtn.dataset.available === '0'; });
  });

  /* Gallery dots (phone swipe) */
  var gallery = pdp.querySelector('[data-as-gallery]'), dots = pdp.querySelector('[data-as-dots]');
  if (gallery && dots) gallery.addEventListener('scroll', function () {
    var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
    Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-on', j === i); });
  }, { passive: true });

  /* Sticky add bar once the main button has scrolled away */
  var sticky = document.querySelector('[data-as-sticky]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(addBtn);
    sticky.querySelector('[data-as-sticky-btn]').addEventListener('click', function () {
      addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!addBtn.disabled) form.requestSubmit();
    });
  }

  /* Item stats: fill bars when the card is on screen */
  var stats = pdp.querySelector('[data-as-stats]');
  if (stats) {
    var run = function () {
      if (stats.classList.contains('is-go')) return;
      stats.classList.add('is-go');
      var sold = stats.querySelector('[data-sold]');
      if (sold) sold.querySelector('.as-sold__fill').style.width = sold.dataset.sold + '%';
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) run(); }, { threshold: 0.4 }).observe(stats);
    } else { run(); }
  }
})();
